import {
    ComponentSettingsChartDataQueriesTable,
    ComponentSettingsManageFiltersDataQueries,
    RendererFilter,
    SOFT_GROUPING_PARENT_MAP_KEY,
} from '@report-content';
import { resolveParentFilter } from './getAvailableParentFilters';

export default function buildDataQueries(fields: RendererFilter[], onlyDisplayRelevantValues: boolean = false) {
    let dataQueries: ComponentSettingsManageFiltersDataQueries = { skip: true };
    fields
        .filter((field) => field.filter_column == 'Y')
        .forEach((field) => {
            if ('dropdown' == field.filterType || 'multiselect' == field.filterType) {
                const parentField = resolveParentFilter(field, fields, onlyDisplayRelevantValues);
                let dq: ComponentSettingsChartDataQueriesTable = {
                    resultFields: parentField
                        ? [field.reference_name, parentField.reference_name]
                        : [field.reference_name],
                    sort: [{ field: field.reference_name, dir: 'DESC' === field.sortDirection ? 'DESC' : 'ASC' }],
                    resultFieldAggregations: {},
                    distinct: true,
                };

                if ('Y' == field?.use_external_filter_value) {
                    dq['isExternalFilter'] = true;
                }

                if (parentField) {
                    dq['softGrouping'] = { [parentField.reference_name]: { key: SOFT_GROUPING_PARENT_MAP_KEY } };
                }

                dataQueries[field.reference_name] = dq;
            } else if ('range' == field.filterType || 'charting_interval' == field.filterType) {
                const rfaMin: any = {};
                const rfaMax: any = {};
                rfaMin[field.reference_name] = 'Min';
                dataQueries[`${field.reference_name}-from`] = {
                    resultFields: [field.reference_name],
                    resultFieldAggregations: rfaMin,
                };
                rfaMax[field.reference_name] = 'Max';
                dataQueries[`${field.reference_name}-to`] = {
                    resultFields: [field.reference_name],
                    resultFieldAggregations: rfaMax,
                };
            }
        });
    return dataQueries;
}
